// 格式化时间显示
function formatCountDownDHMS(ms) {
  if (ms <= 0) {
    return {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
    }
  }

  const totalSeconds = ms / 1000
  let lastSec = 0

  const days = Math.floor(totalSeconds / 86400)
  lastSec = totalSeconds % 86400

  const hours = Math.floor(lastSec / 3600)
  lastSec = lastSec % 3600

  const minutes = Math.floor(lastSec / 60)
  const seconds = Math.floor(lastSec % 60)

  return {
    days: String(days).padStart(2, '0'),
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  }
}

// 格式化时间显示
function formatCountDownHMS(ms) {
  if (ms <= 0) {
    return {
      hours: '00',
      minutes: '00',
      seconds: '00',
    }
  }

  const totalSeconds = Math.floor(ms / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  }
}

// 格式化时间显示
function formatCountDownMS(ms) {
  if (ms <= 0) {
    return {
      minutes: '00',
      seconds: '00',
    }
  }

  const totalSeconds = Math.floor(ms / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return {
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  }
}

export class CountDown {
  constructor() {
    this.lastTime = 0
    this.endTime = 0
    this.ended = false
    this.countdownResult = {}
    this.animationFrameId = null
  }

  startCountdown(formatTime) {
    const countdownFn = (currentTime) => {
      // 避免过于频繁的更新
      if (currentTime - this.lastTime >= 1000) {
        const remainingTime = this.endTime - Date.now()

        if (remainingTime <= 0) {
          this.ended = true
          if (formatTime === 'DHMS') {
            this.countdownResult = {
              days: '00',
              hours: '00',
              minutes: '00',
              seconds: '00',
            }
            return
          }
          if (formatTime === 'HMS') {
            this.countdownResult = {
              hours: '00',
              minutes: '00',
              seconds: '00',
            }
            return
          }
          if (formatTime === 'MS') {
            this.countdownResult = {
              minutes: '00',
              seconds: '00',
            }
            return
          }
        }

        if (formatTime === 'DHMS') {
          this.countdownResult = formatCountDownDHMS(remainingTime)
        }
        if (formatTime === 'HMS') {
          this.countdownResult = formatCountDownHMS(remainingTime)
        }
        if (formatTime === 'MS') {
          this.countdownResult = formatCountDownMS(remainingTime)
        }

        this.lastTime = currentTime
      }

      // 继续下一帧
      this.animationFrameId = requestAnimationFrame(countdownFn)
    }

    this.animationFrameId = requestAnimationFrame(countdownFn)
  }

  initCountDown(targetTime, formatTime = 'DHMS', useTimemills = false) {
    // 使用时间戳
    if (useTimemills) {
      this.endTime = targetTime
    }
    // 使用秒
    else {
      this.endTime = Date.now() + targetTime * 1000
    }

    this.startCountdown(formatTime)
  }
}

export default CountDown
